import * as React from "react";
import { navigateTo } from "gatsby-link";

interface DocFileCellProps {
	title: string;
	link: string;
	isSelected: boolean;
	isInDrawer?: boolean; // whether or not this DocFileCell is loaded inside the mobile Drawer or not

	closeDrawer?(): any;
}

/**
 * document file cell for display in a page sidebar
 */
class DocFileCell extends React.Component<DocFileCellProps, any> {
	state = {
		isHovered: false,
	};

	navigateTo = () => {
		navigateTo(this.props.link);

		// When we are inside of the Mobile drawer, close the drawer after navigating
		if (this.props.isInDrawer) {
			setTimeout(() => this.props.closeDrawer(), 0); // timeout needed for CSS transition purposes
		}
	};

	render() {
		return (
			<div
				style={{
					cursor: "pointer",
					color: this.props.isSelected ? "white" : this.state.isHovered ? "black" : "#636363",
					backgroundColor: this.props.isSelected
						? "#607D8B"
						: this.state.isHovered
							? "#F0F2F7"
							: "",
					paddingLeft: "1.61em",
					paddingRight: 10,
					paddingTop: "0.3em",
					paddingBottom: "0.3em",
				}}
				onClick={this.navigateTo}
				onMouseOver={() => this.setState({ isHovered: true })}
				onMouseOut={() => this.setState({ isHovered: false })}
			>
				{this.props.title}
			</div>
		);
	}
}

export default DocFileCell;



// WEBPACK FOOTER //
// ./src/components/DocFileCell.tsx